import { render, staticRenderFns } from "./recordCard.vue?vue&type=template&id=d762363a&scoped=true"
import script from "./recordCard.vue?vue&type=script&lang=js"
export * from "./recordCard.vue?vue&type=script&lang=js"
import style0 from "./recordCard.vue?vue&type=style&index=0&id=d762363a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d762363a",
  null
  
)

export default component.exports